/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { SearchResponseModel } from "~/feature/Search/generated-types";
import { SearchFilterModel } from "~/feature/Search/generated-types";

export const qafilahSearchContentServiceMeta: Meta<typeof qafilahSearchContentService> = {
	allSearch: ["GET", "/api/v1/qafilah/search/content/all/:context"],
};

// Feature.Search.WebApi.QafilahSearchContentApiController
export const qafilahSearchContentService = {
	async allSearch(context: /* Guid */ string, queryStrings: SearchFilterModel) {
		return await http.fetch<SearchResponseModel, undefined>(qafilahSearchContentServiceMeta.allSearch, { params: { context }, queryStrings });
	},
};
